import {InjectionToken} from '@angular/core';
export const CreationServiceInjectorToken = new InjectionToken('one');
